/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vivid_That_Mink_GreetInputs */

const fr_vivid_that_mink_greet = /** @type {(inputs: Vivid_That_Mink_GreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

/**

* @param {Vivid_That_Mink_GreetInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const vivid_that_mink_greet = /** @type {((inputs?: Vivid_That_Mink_GreetInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vivid_That_Mink_GreetInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_vivid_that_mink_greet(inputs)
});